// Function to replace h1 with h3 inside iframe
function replaceH1InIframe() {
  const iframe = document.getElementById('ba-widget-iframe');
  
  if (iframe) {
    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      const h1Element = iframeDoc.querySelector('.ba_initial_state_title');
      
      if (h1Element) {
        const h3Element = iframeDoc.createElement('h3');
        h3Element.innerHTML = h1Element.innerHTML;
        h3Element.className = h1Element.className;
        h1Element.parentNode.replaceChild(h3Element, h1Element);
        console.log('Successfully replaced h1 with h3 in iframe');
        return true;
      }
    } catch (e) {
      console.log('Cannot access iframe content (cross-origin restriction):', e.message);
      return false;
    }
  }
  return false;
}

// Watch for iframe and content to load
const observer = new MutationObserver(function() {
  const iframe = document.getElementById('ba-widget-iframe');
  if (iframe && iframe.contentDocument) {
    // Wait a bit for iframe content to fully load
    setTimeout(() => {
      if (replaceH1InIframe()) {
        observer.disconnect();
      }
    }, 500);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

console.log('Waiting for iframe popup to appear...');